<template>
    <section class="section">
        <div class="title">关注的用户</div>
        <div v-show="!is_loading && !up.follows && !users.length" class="empty">
            <i class="icon-empty"></i>
            {{id === uid ? '你' : 'TA'}}还没有关注过用户哦~~
        </div>
        <div v-show="is_loading" class="empty">
            <div class="loading-big"></div>
        </div>

        <div>
            <div v-for="v in users" :key="v.id" class="user">
                <a :href="`/spaces/${v.id}`" class="thumb" target="_blank" :style="`background-image: url('${v.thumb || 'https://img.vhiphop.top/icon/a.png'}')`"></a>

                <div class="content">
                    <div>
                        <a :href="`/spaces/${v.id}`" class="nico" target="_blank">{{v.nico}}</a>
                    </div>
                    <div class="sign">{{v.sign || '这个人懒死了什么都没有写O(∩_∩)O'}}</div>
                    <div v-if="!v.follow_status && v.id !== uid" @click="follow(v)" class="follow-btn bg">关注</div>
                    <div v-if="v.follow_status === 1" @click="unfollow(v)" class="follow-btn unfollow" @mouseenter="$set(v, 'text', '取消关注')" @mouseleave="$set(v, 'text', '')">{{v.text || '已关注'}}</div>
                    <div v-if="v.follow_status === 2" @click="unfollow(v)" class="follow-btn unfollow" @mouseenter="$set(v, 'text', '取消关注')" @mouseleave="$set(v, 'text', '')">{{v.text || '互相关注'}}</div>
                </div>
            </div>
            <el-pagination v-if="up.follows > 20" background layout="total, prev, pager, next" @current-change="nextPage" :page-size="20" :total="up.follows" class="page"></el-pagination>
        </div>

    </section>
</template>

<script>
    export default {
        props: {
            up: Object,
        },
        data: () => ({
            is_loading: true,
            is_deleting: false,
            is_paging: false,
            users: [],
            followText: '',
        }),
        computed: {
            id() {
                return +this.$route.params.id;
            },
            user() {
                return this.$store.state.user;
            },
            uid() {
                return this.user.id;
            },
            sign() {
                return this.$store.state.sign;
            },
        },
        methods: {
            async nextPage(page) {
                if (this.is_paging) return;
                this.is_paging = true;
                this.users = await this.api.get(`users/${this.id}/follow/users`, {page}).catch(this.err);
                window.scrollTo(0,0);
                this.is_paging = false;
            },
            follow(v) {
                if (v.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.api.post(`users/${v.id}/follow`).then(e => {
                    v.follow_status = e;
                    if (this.id === this.uid) this.$emit('userIncr');
                    v.is_following = false;
                }, e => {
                    v.is_following = false;
                    this.alert.err(e.message);
                });
            },
            unfollow(v) {
                if (v.is_following) return;
                if (!this.uid) return this.sign.sign_box_show = true;

                this.confirm({
                    title: '取消关注',
                    content: `确认要取消关注该用户吗?`,
                    sureCb: async () => {
                        v.is_following = true;
                        if (this.id === this.uid) this.$emit('userDecr');
                        const {follow_status} = v;
                        v.follow_status = 0;
                        await this.api.del(`users/${v.id}/follow`).catch(e => {
                            if (this.id === this.uid) this.$emit('userIncr');
                            v.follow_status = follow_status;
                            this.alert.err(e.message);
                        });
                        v.is_following = false;
                    }
                });
            }
        },
        async beforeMount() {
            this.users = await this.api.get(`users/${this.id}/follow/users`).catch(this.err);
            this.is_loading = false;
        },
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/follow/common.css";
</style>


// WEBPACK FOOTER //
// src/views/space/follow/User.vue